import { CSSObject, useTheme } from '@core-ui/react-stitch';

const getTagLinkGroupStyles = (): CSSObject => ({
  display: 'block',
  margin: 'auto',
  padding: '2rem 1rem',
  width: '100%',
  h2: {
    ...useTheme().brandFont,
    fontSize: '0.875rem'
  },
  a: {
    fontWeight: 350
  }
});

export default getTagLinkGroupStyles;
